module.exports = __webpack_public_path__ + "static/media/top-brand-66.11516e89.png";